// console.log('ip-location.js init');

(function () {
    $.get('http://jsonip.com', function (ip) {

        console.log('IP Address is: ' + ip.ip);

        const settings = {
            "async": true,
            "crossDomain": true,
            "url": "https://telize-v1.p.rapidapi.com/location/154.6.18.43?callback=getlocation",
            "method": "GET",
            "headers": {
                "x-rapidapi-key": "57fdb7f44cmsh493d670c4ed3c96p1c9fc5jsn4ae56fb08394",
                "x-rapidapi-host": "telize-v1.p.rapidapi.com"
            }
        };
        
        $.ajax(settings).done(function (response) {
            console.log(response);
        });


        // $.ajax('http://ipinfo.io/' + ip.ip + '?token=f574d6ee28df22') // pretty good
        //     .then((res) => {
        //     console.log(res);
        // })
        
        // $.ajax('https://api.ipgeolocation.io/ipgeo?apiKey=' + '5c6f9eb716ae4c47ba0da620c067999f&ip=' + ip.ip) // OK for US
        //     .then((res) => {
        //     console.log(res);
        // })
    });

    // $.ajax('https://geolocation-db.com/json/09ba3820-0f88-11eb-9ba6-e1dd7dece2b8') // doesn't work well for US
    // .then(
    //     function success(response) {
    //         let locationData = JSON.parse(response);
    //         console.log(locationData);

    //         theme.settings.ipLocation.country = locationData.country_name;
    //         theme.settings.ipLocation.state = locationData.state;
    //         theme.settings.ipLocation.city = locationData.city;
    //         theme.settings.ipLocation.postal = locationData.postal;
    //     },

    //     function fail(data, status) {
    //         console.log('Request failed.  Returned status of ',status);
    //     }
    // )
    // .then(
    //     // function () {
    //     //     console.log(theme.settings.ipLocation.country);
    //     // }
    
    // );
})();


